<template>
  <b-container :fluid="true">
    <router-view />
  </b-container>
</template>

<script>
  export default {
    name: "PrivateFormulars",
  };
</script>

<style>
</style>
